import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { EasmAssetsInventoryDataProviderFactory } from '../factory/EasmAssetsInventoryDataProviderFactory';
import { EasmAssetsInventoryGridViewData } from '../types';
import { EasmAssetsInventoryGridViewDataProvider } from '../dataProvider/EasmAssetsInventoryViewDataProvider';

export class EasmAssetsInventoryRepository extends BaseWebComponentRepository {
  public dataProviderFactory: EasmAssetsInventoryDataProviderFactory;
  public dataProvider: EasmAssetsInventoryGridViewDataProvider;

  public constructor() {
    super();

    this.initialSetup({
      dataProviderFactory: new EasmAssetsInventoryDataProviderFactory(),
    });
  }

  public getDataForView(): Promise<EasmAssetsInventoryGridViewData> {
    return this.dataProvider.getDataForView();
  }
}
